<template>
	<div class="image-input">
		<label :style="{width: width ? width + 'px' : '100%', height: height ? height + 'px' : 'initial'}" class="clearfix">
			<canvas></canvas>
			<i v-if="!srcDefault" v-show="!preview" class="icon fa fa-picture-o"></i>
			<img v-if="srcDefault" v-show="!preview" :class="{avatar: avatar}" :src="srcDefault">
			<img v-show="preview" :class="{avatar: avatar}" :src="preview">
			<input @change="imageChanged" class="input" name="image" type="file">
			<div class="overlay"></div>
			<i class="icon-load fa fa-upload"></i>
		</label>
	</div>
</template>

<script>
module.exports = {
	name: 'f-image',
	props: {
		value: String,
		srcDefault: {type: String, default: ''},
		width: {type: Number, default: 40},
		height: {type: Number, default: 40},
		avatar: {type: Boolean, default: true},
		uploadEndpoint: {type: String, default: ''}
	},
	data: function () {
		return {
			selected: ''
		};
	},
	computed: {
		preview: function () {
			return this.selected || this.value;
		}
	},
	methods: {
		imageChanged: function (event) {
			var input = event.target;

			if (input.files && input.files[0]) {
				var reader = new FileReader();

				reader.onload = (e) => {
					var resizeImg = document.createElement('img');
					var resizeCanvas = this.$el.querySelector('canvas');
					var resizeContext = resizeCanvas.getContext('2d');

					resizeImg.onload = () => {
						let width = this.width || this.height * resizeImg.width / resizeImg.height;
						let height = this.height || this.width * resizeImg.height / resizeImg.width;
						resizeCanvas.width = width;
						resizeCanvas.height = height;
						resizeContext.fillColor = '#000';
						resizeContext.rect(0, 0, width, height);
						resizeContext.fill();
						resizeContext.drawImage(resizeImg, 0, 0, width, height);

						this.selected = resizeCanvas.toDataURL('image/png');
						if (this.uploadEndpoint) {
							resizeCanvas.toBlob((blob) => {
								let data = new FormData();
								data.append('image', blob, 'image.png');
								this.$http.put(this.uploadEndpoint, data).then((result) => {
									this.$emit('input', 'upload');
								}).catch(this.$http.toastCatcher);
							}, 'image/png');
						} else {
							this.$emit('input', this.selected);
						}
					};

					resizeImg.src = e.target.result;
				};

				reader.readAsDataURL(input.files[0]);
			} else {
				this.selected = '';
				this.$emit('input', this.selected);
			}
		}
	}
};
</script>
<style>
.image-input {
	display: block;
	text-align: center;
	margin: 11px 0;
}

.image-input > label {
	background: #eee;
	display: inline-block;
	border-radius: 1px;
	padding: 2px 5px;
	margin: 0;
	position: relative;
	box-sizing: content-box;
}

.image-input > label > canvas {
	display: none;
}

.image-input > label > img {
	display: inline-block;
	height: 100%;
	margin: 0;
}

.image-input > label > .icon {
	color: #ccc;
	font-size: 30px;
	cursor: default;
}

.image-input > label > .icon-load {
	color: #eee;
	font-size: 30px;
	cursor: default;
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -0.5ex;
	margin-top: -0.5em;
	opacity: 0;
	transition: 0.4s opacity;
}

.image-input > label > .overlay {
	background-color: #888;
	opacity: 0;
	position: absolute;
	left: 50%;
	width: 50%;
	min-width: 45px;
	max-width: 200px;
	transform: translateX(-50%);
	top: 0;
	bottom: 0;
	transition: 0.3s opacity;
}

.image-input > label:hover > .overlay {
	opacity: 0.8;
}

.image-input > label:hover > .icon-load {
	opacity: 1;
}


.image-input > label > input[type="file"] {
	display: block;
	font-size: 30px;
	opacity: 0;
	width: 0;
	height: 0;
	float: left;
	pointer-events: none;
	visibility: hidden;
}

</style>



// WEBPACK FOOTER //
// f-image.vue?49533640